// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__uysqr","boxTitle":"Qualiphy_boxTitle__2f3id","box":"Qualiphy_box__1LZSe","toggleWrap":"Qualiphy_toggleWrap__31_ZL"};